export default __webpack_public_path__ + "static/media/aisthisi-10.00d05df7.png";